function Icon({ className = 'size-6', name, viewBox }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox={viewBox}
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={`#${name}`} x="0" y="0" />
    </svg>
  )
}

export default Icon
